import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ConsumptionCalendarResult,
  ConsumptionComparisonResult,
  GetConsumptionCalendarParams,
  GetConsumptionComparisonParams,
} from '@/features/consumption/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const consumptionApi = createApi({
  reducerPath: 'consumptionApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/consumption',
  }),
  tagTypes: ['Consumption'],
  endpoints: builder => ({
    getConsumptionCalendar: builder.query<
      ConsumptionCalendarResult,
      GetConsumptionCalendarParams
    >({
      query: params => ({
        url: '/calendar',
        params,
      }),
      providesTags: ['Consumption'],
    }),
    getConsumptionComparison: builder.query<
      ConsumptionComparisonResult,
      GetConsumptionComparisonParams
    >({
      query: params => ({
        url: '/comparison',
        params,
      }),
      providesTags: ['Consumption'],
    }),
  }),
});

export const {
  useGetConsumptionCalendarQuery,
  useGetConsumptionComparisonQuery,
} = consumptionApi;
